// Privacy Cookie Page
export function CookiePage() {
  return `
    <section class="section bg-gray-50 min-h-screen py-12">
      <div class="container max-w-3xl mx-auto bg-white rounded-lg shadow-md p-8">

        <h1 class="text-2xl font-bold mb-6 text-gray-900">Política de Cookies</h1>

        <p class="mb-4 text-gray-700">
          En CeeCasasEspana.com utilizamos cookies y tecnologías similares para garantizar el correcto funcionamiento del sitio web, mejorar la experiencia de usuario y analizar de forma anónima el uso del sitio. Tratamos los datos de conformidad con el Reglamento General de Protección de Datos (RGPD/AVG).
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-2 text-gray-800">¿Qué son las cookies?</h2>
        <p class="mb-4 text-gray-700">
          Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio web. Permiten que el sitio recuerde información sobre tu visita, como tus preferencias, y ayudan a mejorar la navegación y el rendimiento del sitio.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-2 text-gray-800">¿Qué tipos de cookies utilizamos?</h2>
        <ul class="list-disc pl-6 mb-4 text-gray-700">
          <li>
            <strong>Cookies técnicas y funcionales:</strong>
            Son necesarias para el funcionamiento básico del sitio web, como la navegación, la seguridad y el uso de formularios de contacto y reserva.
          </li>
          <li>
            <strong>Cookies de análisis:</strong>
            Utilizamos Google Analytics únicamente con fines estadísticos y de mejora del sitio web. La dirección IP se anonimiza antes de su almacenamiento y los datos recopilados no se utilizan con fines publicitarios ni de elaboración de perfiles.
          </li>
          <li>
            <strong>No utilizamos cookies de publicidad ni cookies de seguimiento con fines comerciales.</strong>
          </li>
        </ul>

        <h2 class="text-xl font-semibold mt-6 mb-2 text-gray-800">Gestión del consentimiento</h2>
        <p class="mb-4 text-gray-700">
          Al acceder por primera vez a nuestro sitio web, se te mostrará un aviso de cookies donde podrás aceptar o rechazar las cookies de análisis. Las cookies técnicas se utilizan únicamente cuando son necesarias para el funcionamiento del sitio.
        </p>
        <p class="mb-4 text-gray-700">
          En cualquier momento puedes modificar o retirar tu consentimiento mediante el icono de configuración de cookies disponible en el sitio web.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-2 text-gray-800">Retirada del consentimiento</h2>
        <p class="mb-4 text-gray-700">
          Puedes retirar o modificar tu consentimiento en cualquier momento, sin que ello afecte a la licitud del tratamiento realizado previamente, utilizando la configuración de cookies disponible en el sitio.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-2 text-gray-800">Tus derechos</h2>
        <p class="mb-4 text-gray-700">
          De acuerdo con el RGPD/AVG, tienes derecho a acceder, rectificar y suprimir tus datos personales, así como otros derechos detallados en nuestra
          <a href="/privacy/" class="text-blue-600 hover:underline">Política de Privacidad</a>.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-2 text-gray-800">Contacto</h2>
        <p class="mb-4 text-gray-700">
          Si tienes preguntas sobre nuestra política de cookies, puedes contactarnos a través de nuestro
          <a href="/contact/" class="text-blue-600 hover:underline">formulario de contacto</a>.
        </p>

        <p class="text-xs text-gray-400 mt-8">
          Última actualización: 17-12-2025
        </p>

      </div>
    </section>
  `;
}
